export class UserRoleWithPrefix {
  public static get ROLE_DEV(): string {
    return "ROLE_DEV";
  }

  public static get ROLE_USER(): string {
    return "ROLE_USER";
  }

  public static get ROLE_ADMIN(): string {
    return "ROLE_ADMIN";
  }
}
